import { apiPost } from '../_common';

export default {
  generateLabels(shipmentId, orderIds) {
    const request = {
      shipmentId,
      orderIds,
    };

    return apiPost('/magenta/fulfillment/smart-label', request)
      .then(result => result.response);
  },
};
